import React from 'react'
import { EmarModuleCard, FamilyPlanModuleCard } from '@lmc/ui-kit'
import { PaywallTemplateWrapper } from '../PaywallTemplateWrapper'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { getNominative } from 'common/utils'

interface StateProps {
  preferredPeopleNominative?: string
}

export const AboutMePaywallComponent: React.FC<StateProps> = ({
  preferredPeopleNominative
}) => {
  const nominative = getNominative(
    preferredPeopleNominative,
    'resident'
  ).toLowerCase()
  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title="About Me"
      subTitle={`Bring the person to the forefront of your care and minimise risks with this extended set of questions attached to the profile designed to capture the voice, needs and challenges of your ${nominative}.`}
      bodyText={`Use ‘About me’ to empower your ${nominative}`}
      icon={IconType.DocsHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'From good to outstanding with LMC',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://www.logmycare.co.uk/blog/from-good-to-outstanding-with-log-my-care',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'What features can I access with Pro?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'How much does it cost?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/articles/1584269-how-much-does-it-cost',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/pricing"
      customLinkText="Read more"
    />
  )
}

export const AboutMePaywall = AboutMePaywallComponent
